import React from 'react';

type LogoImageProps = {
    src: string;
    alt?: string;
    url?: string;
};

const logoTWClasses =
    'tw-block tw-h-auto tw-max-w-full mob-l:tw-w-[210px] tw-min-h-[50px] tw-object-contain tw-relative tw-transition-all tw-duration-[1.1s] tw-ease-out';

function LogoImage({ src, alt, url }: LogoImageProps) {
    return (
        <>
            {url ? (
                <a href={url} className="tw-flex tw-items-stretch">
                    <img
                        src={src}
                        className={`${logoTWClasses}`}
                        alt={alt}
                        loading="lazy"
                        width="210"
                        height="82"
                    />
                </a>
            ) : (
                <img
                    src={src}
                    className={`${logoTWClasses}`}
                    alt={alt}
                    loading="lazy"
                    width="210"
                    height="82"
                />
            )}
        </>
    );
}
export default LogoImage;
